<template>
  <b-container fluid>
    <b-row
      :class="[
        'select-any-preference-input',
        { 'question-form': forQuestionForm },
      ]"
    >
      <b-col cols="12" class="d-flex p-0">
        <div class="checkbox-wrapper">
          <b-form-checkbox
            v-for="option in options"
            :key="option.id"
            :id="`preference_variable_wrapper_${option.id}`"
            :value="1"
            :unchecked-value="0"
            :checked="option.value"
            :inline="false"
            :disabled="option.disabled"
            :class="[{ 'mt-2 pt-2': forQuestionForm }, 'v3_control_checkbox']"
            @change="(val) => onChangeHandler(option.variable, val)"
          >
            <span>{{ option.text }}</span>
            <b-tooltip
              v-if="isSelectAnyCheckboxDisabledByMaxSelections(option.variable)"
              :target="`preference_variable_wrapper_${option.id}`"
              placement="left"
            >
              You can only pick a maximum of
              {{ jobQuestion.maximum_selections }} selections.
            </b-tooltip>
            <b-tooltip
              v-else-if="
                isSelectAnyCheckBoxDisabledByExclusive(option.variable)
              "
              :target="`preference_variable_wrapper_${option.id}`"
              placement="left"
              triggers="focus click"
            >
              This option cannot be selected when
              {{ exclusiveVariable.input_label }} is already selected.
            </b-tooltip>
            <b-tooltip
              v-else-if="
                exclusiveVariable &&
                exclusiveVariable.id === option.id &&
                anyNonExclusiveSelected
              "
              :target="`preference_variable_wrapper_${option.id}`"
              placement="left"
              triggers="focus click"
            >
              This option cannot be selected when any other option is already
              selected.
            </b-tooltip>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';

export default {
  name: 'SelectAnyPreferenceInput',
  mixins: [validationMixin, SubFormValidationMethodsMixin],
  props: {
    jobQuestion: {
      required: true,
    },
    forQuestionForm: {
      type: Boolean,
      default: false,
    },
    studyQuestion: Object,
  },
  validations: {
    selected: {},
  },
  computed: {
    options: function () {
      return this.jobQuestion.jobQuestionVariables.map((variable) => ({
        id: variable.id,
        variable,
        text: variable.input_label,
        value:
          (variable.jobProfileQuestionResponses[0] || {}).value === 1 ? 1 : 0,
        disabled: this.isSelectAnyCheckboxDisabledByMaxSelections(variable),
      }));
    },
    answeredVariables: function () {
      return this.jobQuestion.jobQuestionVariables.filter((v) => {
        return (
          v.jobProfileQuestionResponses[0] &&
          v.jobProfileQuestionResponses[0].value === 1
        );
      });
    },
    exclusiveVariable: function () {
      return this.jobQuestion.jobQuestionVariables.find(
        (v) => v.is_exclusive_member
      );
    },
    anyNonExclusiveSelected: function () {
      return this.jobQuestion.jobQuestionVariables.some(
        (variable) =>
          (variable.jobProfileQuestionResponses[0] || {}).value === 1 &&
          !variable.is_exclusive_member
      );
    },
  },
  methods: {
    onChangeHandler: function (variable, value) {
      const alreadyDirty = this.$v.selected.$dirty;
      this.$emit('set-preference', variable.id, value);
      this.$v.selected.$touch();
      this.$nextTick(() => {
        if (
          this.isSelectAnyCheckBoxDisabledByExclusive(variable) ||
          (this.exclusiveVariable &&
            this.exclusiveVariable.id === variable.id &&
            this.anyNonExclusiveSelected)
        ) {
          this.$emit('set-preference', variable.id, 0);
          alreadyDirty || this.$v.selected.$reset();
        }
      });
    },
    isSelectAnyCheckboxDisabledByMaxSelections: function (variable) {
      if (
        (variable.jobProfileQuestionResponses[0] &&
          parseInt(variable.jobProfileQuestionResponses[0].value) === 1) ||
        this.jobQuestion.maximum_selections === 0
      ) {
        return false;
      }
      return (
        this.jobQuestion.maximum_selections <= this.answeredVariables.length
      );
    },
    isSelectAnyCheckBoxDisabledByExclusive: function (variable) {
      if (!this.exclusiveVariable) return false;
      return (
        this.exclusiveVariable.id !== variable.id &&
        (this.exclusiveVariable.jobProfileQuestionResponses[0] || {}).value ===
          1
      );
    },
  },
};
</script>

<style lang="scss">
.v3_control_radio_group .custom-control > .custom-control-label{
  font-size: .875rem !important;
}
</style>
